var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tz",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M10 0h160v120H10z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#a)",
    transform: "matrix(4 0 0 4 -40 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#09f",
    d: "M0 0h180v120H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M0 0h180L0 120V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120h40l140-95V0h-40L0 95v25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 91.5 137.2 0h13.5L0 100.5v-9zM29.3 120 180 19.5v9L42.8 120H29.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/tz.d03864606ac83da1d9a38b9925eaf749.svg";
export { ForwardRef as ReactComponent };